export const redirect = [
  {
    // eslint-disable-next-line
    from: '(?!^\/$|^\/[?].*$)(.*\/[?](.*)$|.*\/$)',
    to: (from : any, req : any) => {
      const base = req._parsedUrl.pathname.replace(/\/$/, '');
      const search = req._parsedUrl.search;
      return base + (search != null ? search : '');
    }
  }
];



